import listmodule from './list.js';
import { REFRESHLIST_DATE, REFRESHLIST_REFRESHDATE,REFRESHLIST_REFRESHENDDATE } from '../actions/refreshlistactions';
const state = {
    ...listmodule.state,
    refreshdate: new Date(),
    date: new Date(),
    refreshenddate: new Date(),
};

const getters = {
    ...listmodule.getters,
    date: state => state.date,
    refreshdate: state => state.refreshdate,
    refreshenddate: state => state.refreshenddate,
};

const actions = {
    ...listmodule.actions,
    [REFRESHLIST_DATE]: ({ commit }, date) => {

        commit(REFRESHLIST_DATE, date);
    },
    [REFRESHLIST_REFRESHDATE]: ({ commit }, refreshdate) => {

        commit(REFRESHLIST_REFRESHDATE, refreshdate);
    },
    [REFRESHLIST_REFRESHENDDATE]: ({ commit }, refreshenddate) => {

        commit(REFRESHLIST_REFRESHENDDATE, refreshenddate);
    },
};

const mutations = {
    ...listmodule.mutations,
    [REFRESHLIST_DATE]: (state, date) => {
        state.date = date;
    },
    [REFRESHLIST_REFRESHDATE]: (state, refreshdate) => {
        state.refreshdate = refreshdate;
    },
    [REFRESHLIST_REFRESHENDDATE]: (state, refreshenddate) => {
        state.refreshenddate = refreshenddate;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};